export default function BulletListIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.5"
      height="15"
      viewBox="0 0 18.5 15"
    >
      <g transform="translate(-2.5 -4.5)">
        <path
          fill="currentColor"
          d="M4 10.5A1.5 1.5 0 105.5 12 1.5 1.5 0 004 10.5zm0-6A1.5 1.5 0 105.5 6 1.5 1.5 0 004 4.5zm0 12A1.5 1.5 0 105.5 18 1.5 1.5 0 004 16.5zM8 19h12a1 1 0 000-2H8a1 1 0 000 2zm0-6h12a1 1 0 000-2H8a1 1 0 000 2zM7 6a1 1 0 001 1h12a1 1 0 000-2H8a1 1 0 00-1 1z"
          data-name="Path 10633"
        ></path>
      </g>
    </svg>
  );
}
